export const language: any = {
    cancel: "取消",
    ok: "确认",
};